import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { User, Shield } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { ProfileTab, AccountTab } from '../components/settings';

const SettingsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'profile';

  const handleTabChange = (tab) => {
    setSearchParams({ tab });
  };

  return (
    <div className="flex-1 py-8">
      <div className="container mx-auto px-4 max-w-4xl">
          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-heading font-bold">Settings</h1>
            <p className="text-foreground-muted mt-1">Manage your profile, preferences and account</p>
          </div>

          <Tabs value={activeTab} onValueChange={handleTabChange}>
            <TabsList className="grid grid-cols-2 mb-8 bg-white/[0.02]">
              <TabsTrigger value="profile" className="flex items-center gap-2">
                <User className="h-4 w-4" />
                <span className="hidden sm:inline">Profile</span>
              </TabsTrigger>
              <TabsTrigger value="account" className="flex items-center gap-2">
                <Shield className="h-4 w-4" />
                <span className="hidden sm:inline">Account</span>
              </TabsTrigger>
            </TabsList>

            <TabsContent value="profile">
              <ProfileTab />
            </TabsContent>
            <TabsContent value="account">
              <AccountTab />
            </TabsContent>
          </Tabs>
      </div>
    </div>
  );
};

export default SettingsPage;
